import { gql } from '@apollo/client';
import React from 'react';
import TableCell from '../../../components/TableCell';
import Text from '../../../components/Text';
import { OrganisationListItemFragment } from '../../../generated/graphql';
import { ListItemComponent } from '../../../types';
import { useNavigate } from '../../../hooks/useNavigate';
import { Checkbox } from '@blueprintjs/core';
import { noop } from '../../../helpers/utils';

export type OrganisationListProps = {
  item: OrganisationListItemFragment;
  skeleton?: boolean;
} & ListItemComponent;

const OrganisationListItem = ({ item, skeleton, selected, onToggle }: OrganisationListProps) => {
  const navigate = useNavigate();
  return (
    <tr onClick={onToggle || skeleton ? noop : navigate(`/organisations/${item!.id}`)}>
      {onToggle && (
        <TableCell>
          <Checkbox inline disabled={skeleton} checked={selected} onChange={() => onToggle(item.id)} className="m-0" />
        </TableCell>
      )}
      <TableCell>
        <Text skeleton={skeleton}>{item.name}</Text>
      </TableCell>
    </tr>
  );
};

OrganisationListItem.fragments = {
  organisation: gql`
    fragment OrganisationListItem on Organisation {
      id
      name
    }
  `,
};

export default OrganisationListItem;
